import axios from 'axios';

const WP_BASE_URL = 'https://gemnoble.com/wp-json/wp/v2';

// ===== Auth Helpers =====

export const isWordPressAuth = () =>
    localStorage.getItem('authType') === 'wordpress';

export const getWpToken = () =>
    isWordPressAuth() ? localStorage.getItem('token') : null;

const getWordPressToken = () => {
    if (isWordPressAuth()) return getWpToken();
    return 'c29tcHJhc29uZzpwWGRoIGM1bmkgS0dJZiBPU0xBIEhiSkEgSDZPTg==';
};

// ===== WordPress API Client (axios) =====

export const createWordPressApiClient = (token) =>
    axios.create({
        baseURL: WP_BASE_URL,
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Basic ${token}`
        }
    });

export const getCurrentWpUser = async (token) => {
    const client = createWordPressApiClient(token);
    const response = await client.get('/users/me');
    return response.data;
};

export const validateWpCredentials = async (username, password) => {
    try {
        const token = btoa(`${username}:${password}`);
        const client = createWordPressApiClient(token);
        const response = await client.get('/users/me');
        return { success: true, token, user: response.data };
    } catch (error) {
        return {
            success: false,
            message: error.response?.data?.message || 'WordPress authentication failed'
        };
    }
};

// ===== Media =====

export const deleteMedia = (mediaID) => {
    console.log('Deleting Media ID : ' + mediaID);
    return new Promise((resolve, reject) => {
        const headers = new Headers();
        headers.append('Authorization', 'Basic ' + getWordPressToken());
        fetch(`${WP_BASE_URL}/media/${mediaID}?force=1`, {
            method: 'DELETE',
            headers,
            redirect: 'follow'
        })
            .then(response => response.text())
            .then(result => {
                resolve(result);
                console.log('Media ID : ' + JSON.parse(result).previous.id + ' has Deleted');
            })
            .catch(error => {
                reject(error);
                console.error(error);
            });
    });
};

export const getImagePlaceHolder = () => {
    return new Promise((resolve, reject) => {
        const headers = new Headers();
        headers.append('Authorization', 'Basic ' + getWordPressToken());
        fetch(`${WP_BASE_URL}/media/30`, {
            method: 'GET',
            headers,
            redirect: 'follow',
            mode: 'no-cors'
        })
            .then(response => response.text())
            .then(result => resolve(result))
            .catch(error => {
                reject(error);
                console.error(error);
            });
    });
};

export const uploadImages = (imageFilesSelected, uploadStatus, uploadMessage) => {
    return new Promise(async (resolve, reject) => {
        const imagesList = [];
        uploadStatus(true);
        for (let i = 0; i < imageFilesSelected.length; i++) {
            uploadMessage('Uploading Image : ' + imageFilesSelected[i].name);
            const headers = new Headers();
            headers.append('Content-Type', 'image/jpeg');
            headers.append('Content-Disposition', `form-data; filename="${imageFilesSelected[i].name}"`);
            headers.append('Authorization', 'Basic ' + getWordPressToken());
            await fetch(`${WP_BASE_URL}/media`, {
                method: 'POST',
                headers,
                body: imageFilesSelected[i],
                redirect: 'follow'
            })
                .then(response => response.text())
                .then(result => {
                    imagesList.push(JSON.parse(result));
                    console.log('Uploaded : ' + imageFilesSelected[i].name);
                })
                .catch(error => reject(error));
        }
        resolve(imagesList);
        uploadStatus(false);
        uploadMessage('Uploaded Image done');
    });
};

export const uploadVideos = (videoFilesSelected, uploadStatus, uploadMessage) => {
    return new Promise(async (resolve, reject) => {
        const videosList = [];
        uploadStatus(true);
        for (let i = 0; i < videoFilesSelected.length; i++) {
            uploadMessage('Uploading Video : ' + videoFilesSelected[i].name);
            const headers = new Headers();
            headers.append('Content-Type', 'image/jpeg');
            headers.append('Content-Disposition', `form-data; filename="${videoFilesSelected[i].name}"`);
            headers.append('Authorization', 'Basic ' + getWordPressToken());
            await fetch(`${WP_BASE_URL}/media`, {
                method: 'POST',
                headers,
                body: videoFilesSelected[i],
                redirect: 'follow'
            })
                .then(response => response.text())
                .then(result => {
                    videosList.push(JSON.parse(result));
                    console.log('Uploaded : ' + videoFilesSelected[i].name);
                })
                .catch(error => reject(error));
        }
        resolve(videosList);
        uploadStatus(false);
        uploadMessage('Uploaded Video done');
    });
};

export const uploadCerts = (certimgFilesSelected, uploadStatus, uploadMessage) => {
    return new Promise(async (resolve, reject) => {
        const certsList = [];
        uploadStatus(true);
        for (let i = 0; i < certimgFilesSelected.length; i++) {
            uploadMessage('Uploading Certificate : ' + certimgFilesSelected[i].name);
            const headers = new Headers();
            headers.append('Content-Type', 'image/jpeg');
            headers.append('Content-Disposition', `form-data; filename="${certimgFilesSelected[i].name}"`);
            headers.append('Authorization', 'Basic ' + getWordPressToken());
            await fetch(`${WP_BASE_URL}/media`, {
                method: 'POST',
                headers,
                body: certimgFilesSelected[i],
                redirect: 'follow'
            })
                .then(response => response.text())
                .then(result => {
                    certsList.push(JSON.parse(result));
                    console.log('Uploaded : ' + certimgFilesSelected[i].name);
                })
                .catch(error => reject(error));
        }
        resolve(certsList);
        uploadStatus(false);
        uploadMessage('Uploaded Certificate done');
    });
};
